export default __webpack_public_path__ + "static/media/javascript.2888c0a0.webp";